import { render, staticRenderFns } from "./CommonSubitemTemplate.vue?vue&type=template&id=5897b4e0&scoped=true"
import script from "./CommonSubitemTemplate.vue?vue&type=script&lang=js"
export * from "./CommonSubitemTemplate.vue?vue&type=script&lang=js"
import style0 from "./CommonSubitemTemplate.vue?vue&type=style&index=0&id=5897b4e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5897b4e0",
  null
  
)

export default component.exports